// extracted by mini-css-extract-plugin
module.exports = {"mediaGalleryBanner":"MediaGalleryBanner_mediaGalleryBanner__A_CK3","pointer":"MediaGalleryBanner_pointer__OvUhh"};